type ProjectStatusCreationError = {
  message: string;
};

const projectStatusCreationError: ProjectStatusCreationError = {
  message: "",
};

export type { ProjectStatusCreationError };

export { projectStatusCreationError };
